import { notesConstants } from "../constants/notes.constants";

const defaultState = {
	note: null,
}

export default (state = defaultState, action = {}) => {
	switch (action.type) {
		case notesConstants.FETCH_NOTES + '_FULFILLED': {
			return {
				...state,
				notes: action.payload.data.data || action.payload.data,				
				dataFetching: false,
				apiResponseError: null,
			}
		}
		case notesConstants.FETCH_NOTES + '_PENDING': {
			return {
				...state,
				dataFetching: true
			}
		}
		case notesConstants.FETCH_NOTES +'_REJECTED': {
			return {
				...state,
				dataFetching: false,
				apiResponseError: action.payload.response.status,
				apiResponseText: action.payload.response.statusText,
				apiResponseURL: action.payload.response.request.responseURL
			}
		}
        default:
		    return state;
	}
}